// extracted by mini-css-extract-plugin
export default {"popup":"fzlb8RKt5l79EMcIB0WC","dropdownBox":"u70Hyz2igbRX5egQGHKW"};